import React from 'react';

export function LockIcon() {
  return (
    <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5001 24.5793C18.7754 24.5793 19.8093 23.5454 19.8093 22.2701C19.8093 20.9948 18.7754 19.9609 17.5001 19.9609C16.2248 19.9609 15.1909 20.9948 15.1909 22.2701C15.1909 23.5454 16.2248 24.5793 17.5001 24.5793Z"
        fill="#9CA3AF"
      />
      <path
        d="M26.3968 13.4995V11.7287C26.3968 7.9037 25.476 2.83203 17.5002 2.83203C9.52433 2.83203 8.6035 7.9037 8.6035 11.7287V13.4995C4.63683 13.9954 3.3335 16.007 3.3335 20.9512V23.5862C3.3335 29.3945 5.10433 31.1654 10.9127 31.1654H24.0877C29.896 31.1654 31.6668 29.3945 31.6668 23.5862V20.9512C31.6668 16.007 30.3635 13.9954 26.3968 13.4995ZM17.5002 26.547C15.1343 26.547 13.2218 24.6204 13.2218 22.2687C13.2218 19.9029 15.1485 17.9904 17.5002 17.9904C19.8518 17.9904 21.7785 19.917 21.7785 22.2687C21.7785 24.6345 19.866 26.547 17.5002 26.547ZM10.9127 13.372C10.7993 13.372 10.7002 13.372 10.5868 13.372V11.7287C10.5868 7.57786 11.7627 4.81536 17.5002 4.81536C23.2377 4.81536 24.4135 7.57786 24.4135 11.7287V13.3862C24.3002 13.3862 24.201 13.3862 24.0877 13.3862H10.9127V13.372Z"
        fill="#9CA3AF"
      />
    </svg>
  );
}
